import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {SnackbarProvider} from "notistack";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {LicenseInfo} from '@mui/x-date-pickers-pro';

LicenseInfo.setLicenseKey('93593b80f086b75ea9cb82344f4fa361T1JERVI6NDA0NzEsRVhQSVJZPTE2Nzk4NDM2MTEwMDAsS0VZVkVSU0lPTj0x');

const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <SnackbarProvider>
                <App/>
            </SnackbarProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
